var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoInstallation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "-1 -1 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25035 17.9522C7.21027 17.9923 7.14493 17.9911 7.10636 17.9495L6.24468 17.0216C6.20808 16.9822 6.20921 16.9209 6.24724 16.8828L7.38166 15.7484C6.46055 14.6397 6 13.3689 6 11.936C6 10.8443 6.26439 9.85501 6.79318 8.96802C7.33902 8.06397 8.06397 7.34755 8.96802 6.81876C9.87207 6.27292 10.8614 6 11.936 6C13.3689 6 14.6311 6.46055 15.7228 7.38166L16.9525 6.15197C16.9933 6.1112 17.06 6.11326 17.0982 6.15646L17.9377 7.10652C17.9727 7.14611 17.9709 7.20609 17.9335 7.24345L16.7207 8.45629C17.4883 9.4968 17.8721 10.6567 17.8721 11.936C17.8721 13.0107 17.5991 14 17.0533 14.9041C16.5245 15.8081 15.8081 16.533 14.9041 17.0789C14.0171 17.6077 13.0277 17.8721 11.936 17.8721C10.6567 17.8721 9.4968 17.4968 8.45629 16.7463L7.25035 17.9522ZM8.50746 14.6226L14.597 8.53305C13.7783 7.91898 12.8913 7.61194 11.936 7.61194C11.1343 7.61194 10.4009 7.8081 9.73561 8.20043C9.08742 8.57569 8.56716 9.09595 8.17484 9.76119C7.79957 10.4094 7.61194 11.1343 7.61194 11.936C7.61194 12.9595 7.91045 13.855 8.50746 14.6226ZM11.936 16.2601C12.7207 16.2601 13.4371 16.0725 14.0853 15.6972C14.7505 15.3049 15.2793 14.7846 15.6716 14.1365C16.064 13.4712 16.2601 12.7377 16.2601 11.936C16.2601 11.1173 16.0384 10.3412 15.5949 9.60768L9.60768 15.5949C10.29 16.0384 11.0661 16.2601 11.936 16.2601Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoInstallation);
export default __webpack_public_path__ + "static/media/noInstallation.c0a26da89c663adc9a86dd048d5f6461.svg";
export { ForwardRef as ReactComponent };